import './Stuff.css';

import React from 'react';
import { withRouter } from 'react-router-dom';
import classnames from 'classnames';

import Apps from '../Apps/Apps';
import Projects from '../Projects/Projects';

class Stuff extends React.Component {
  constructor() {
    super();
    this.state = {
      section: 'apps'
    };
  }

  isActive(section) {
    return section === this.state.section ? 'active' : null;
  }

  sectionClick(section) {
    this.setState({ section: section });
  }

  render() {
    return (
      <div className="Stuff" ref={container => this.container = container}>
        <div className="SectionButtons">
          <button className={this.isActive('apps')} onClick={() => this.sectionClick('apps')}><h4>Apps</h4></button>
          <button className={this.isActive('projects')} onClick={() => this.sectionClick('projects')}><h4>Projects</h4></button>
        </div>
        <Apps
          className={classnames({ hidden: this.state.section !== 'apps' })}
          changeSection={() => this.sectionClick('apps')}
        />
        <Projects
          className={classnames({ hidden: this.state.section !== 'projects' })}
          changeSection={() => this.sectionClick('projects')}
        />
      </div>
    );
  }

  componentDidMount() {
    if (this.props.location.pathname === '/apps') {
      this.sectionClick('apps');
      setTimeout(() => {
        this.container.scrollIntoView();
      }, 300);
    }
    else if (this.props.location.pathname === '/projects') {
      this.sectionClick('projects');
      setTimeout(() => {
        this.container.scrollIntoView();
      }, 300);
    }
  }
}

export default withRouter(Stuff);



// WEBPACK FOOTER //
// ./src/components/Stuff/Stuff.js